import { apiClient } from '../apiClient';
import { setToken, clearToken, onTokenChange } from '../tokenStorage';

/**
 * Service for authentication and token management
 */
export const authService = {
  /**
   * Set authorization header with JWT token
   * @param token - The JWT token
   */
  setAuthToken: (token: string): void => {
    // Store the token in the token storage
    // The token change listener will automatically update the apiClient headers
    setToken(token);
  },

  /**
   * Clear authorization token
   */
  clearAuthToken: (): void => {
    // Clear the token from storage
    // The token change listener will automatically remove it from the apiClient headers
    clearToken();
  },
};

// Set up a token change listener to automatically update apiClient headers
onTokenChange((token) => {
  if (token) {
    apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  } else {
    delete apiClient.defaults.headers.common['Authorization'];
  }
});
